import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import { utils as tkUtils } from '@adc/ui-core'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const { formatTitleCase } = tkUtils.formatters

const renderValue = (value, definition, customFormatters, row) => {
  const { custom, titleCase = false } = definition.formatOptions || {}
  if (customFormatters && customFormatters[custom]) {
    return customFormatters[custom](value, definition, row)
  } else {
    return titleCase ? formatTitleCase(value) : value
  }
}

const TextCell = props => {
  const { rowIndex, definition, data, customFormatters, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]

  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}_cell`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        data-elm-id={`${baseField}_${rowIndex}_value`}
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(
          _.get(row, field) || row[baseField],
          definition || {},
          customFormatters,
          row
        )}
      </div>
    </Cell>
  )
}

/**
 * formatOptions for TextCell allow for a custom format function defined at the grid level with optional
 * custom arguments. titlecase prop is used for easy to read formatting.
 * e.g. formatOptions: {
 *  custom: 'customFormat',
 *  customOptions: {
 *    foo: 'bar',
 *  },
 *  titleCase: true,
 * }
 */

TextCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    formatOptions: PropTypes.shape({
      custom: PropTypes.string,
      customOptions: PropTypes.object,
      titleCase: PropTypes.bool,
    }),
  }).isRequired,
  data: PropTypes.array,
  customFormatters: PropTypes.object,
}

export default TextCell
